/**
 * Splide only repaints its pagination once a move or a momentum scroll has
 * finished, so on touch devices the dots stay frozen for the whole swipe and
 * then jump several steps at once. Poll the live track position instead and
 * highlight the matching dot on every frame while the slider is in motion.
 *
 * Usage, after creating a Splide instance but before mounting it:
 *   window.SplideLivePagination && window.SplideLivePagination(splide);
 *
 * The bundled `slider-custom` element carries its own copy of this logic in
 * src/slider.ts, since it uses the npm build of Splide rather than the global.
 */
window.SplideLivePagination = function (splide) {
  var CLASS_ACTIVE = 'is-active';

  var frame = 0;
  var lastPosition = NaN;
  var idleFrames = 0;
  var isDragging = false;

  function highlight(page) {
    splide.Components.Pagination.items.forEach(function (item) {
      item.button.classList.toggle(CLASS_ACTIVE, item.page === page);
    });
  }

  function currentPage() {
    var Move = splide.Components.Move;
    var closest = Move.toIndex(Move.getPosition());
    // Loop clones report indices outside [0, length), so wrap them back.
    var index = ((closest % splide.length) + splide.length) % splide.length;
    return splide.Components.Controller.toPage(index);
  }

  function cancel() {
    if (frame) {
      cancelAnimationFrame(frame);
      frame = 0;
    }
  }

  function tick() {
    var position = splide.Components.Move.getPosition();

    if (position === lastPosition) {
      idleFrames += 1;
    } else {
      idleFrames = 0;
      lastPosition = position;
      highlight(currentPage());
    }

    // Keep polling while the finger is down, then until the momentum scroll
    // has settled. The idle counter also guards against a drag that ends
    // without any movement, which emits no further Splide events.
    if (isDragging || idleFrames < 10) {
      frame = requestAnimationFrame(tick);
    } else {
      cancel();
      // Hand the dots back to Splide so classes and ARIA stay in sync.
      splide.Components.Pagination.update();
    }
  }

  splide.on('drag', function () {
    if (!splide.Components.Pagination.items.length) return;

    isDragging = true;
    lastPosition = NaN;
    idleFrames = 0;

    if (!frame) frame = requestAnimationFrame(tick);
  });

  splide.on('dragged', function () {
    isDragging = false;
  });

  splide.on('destroy', cancel);
};
